import { makeStyles } from "@material-ui/styles";

export const useStyles = makeStyles(() => ({
    navy: (props) => ({
        backgroundColor: props?.corPrimaria || "#fa5b6d"
    }),
    root: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        paddingLeft: '0px !important',
        paddingRight: '0px',
    },
    homebackground: {
        position: 'relative',
        height: '100vh',
        overflow: 'hidden',
    },
    red: {
        backgroundColor: '#ff2040',
        color: '#ffffff'
    },
    green: {
        backgroundColor: '#00b020'
    },
    pink: {
        backgroundColor: '#fa5b6d'
    },
    main: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        color: '#ffffff',
        overflow: 'auto',
        overflowX: 'hidden',
        padding: '20px',
    },
    mainrosa: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        color: '#fff',
        overflow: 'auto',
        textShadow: '8px 8px 16px rgba(250, 91, 109, 0.7), -2px -2px 4px rgba(250, 91, 109, 0.7)'
    },
    center: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    largeLogo: {
        height: 240,
        width: 240,
        margin: 24,
        filter: 'drop-shadow(0 8px 16px rgba(0,0,0,0.3))',
    },
    logo: {
        height: 150,
        width: 150,
        filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
    },
    cards: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
    card: {
        margin: 16,
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-8px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.2)',
        },
    },
    title: {
        marginTop: 24,
        marginBottom: 24,
        textShadow: '0 2px 4px rgba(0,0,0,0.3)',
    },
    space: {
        padding: 16,
    },
    media: {
        width: 240,
        height: 240,
        objectFit: 'contain',
        padding: 8,
    },
    largeButton: {
        width: 280,
        height: 80,
        fontSize: '2rem !important',
        fontWeight: 'bold',
        borderRadius: 16,
        boxShadow: '0 8px 16px rgba(0,0,0,0.25)',
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.3)',
        },
    },
    largeInput: {
        width: '80px!important',
        padding: '8px!important',
        fontSize: '2.5rem!important',
        textAlign: 'center!important',
        borderRadius: '8px',
    },
    bordered: {
        borderWidth: 2,
        borderRadius: 12,
        margin: 8,
        borderStyle: 'solid'
    },
    row: {
        display: 'flex',
        padding: 16,
        alignItems: 'center',
    },
    around: {
        justifyContent: 'space-around'
    },
    between: {
        justifyContent: 'space-between'
    },
    column: {
        flexDirection: "column"
    },
    touchFeedback: {
        transition: 'all 0.2s ease',
        '&:active': {
            transform: 'scale(0.97)',
            opacity: '1 !important', // Força opacidade total mesmo quando ativo
        }
    },
    kioskButton: {
        padding: '24px 32px',
        borderRadius: '16px',
        fontSize: '2.2rem',
        fontWeight: 'bold',
        textTransform: 'uppercase',
        boxShadow: '0 8px 20px rgba(0,0,0,0.3)',
        transition: 'all 0.3s ease',
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.4)',
        },
        '&:active': {
            transform: 'translateY(0)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        }
    },
    orderSummaryBox: {
        background: 'rgba(255, 255, 255, 0.9)',
        borderRadius: '20px',
        padding: '20px',
        boxShadow: '0 8px 20px rgba(0,0,0,0.15)',
        marginBottom: '24px',
    }
}));
